import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../../shared/models/async-value';
import { hasPump, hasPumpRMXUL } from '../helpers/should-hide-pump';

export namespace PumpAvailability {
  export class ShouldHide extends BaseAsyncValue<Boolean> {
    getValue(): Observable<Boolean> {
      return hasPump(this.store, this.form).pipe(takeUntil(this.ngDestroy));
    }
  }
  export class RMXULShouldHide extends BaseAsyncValue<Boolean> {
    getValue(): Observable<Boolean> {
      return hasPumpRMXUL(this.store, this.form).pipe(takeUntil(this.ngDestroy));
    }
  }
}
